import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  // --- --- --- Public App --- --- ---
  {
    path: '/', name: 'inicio', component: () => import('layouts/public/PublicLayout.vue'),
    children: [
      { // Inicio
        name: 'page-home',  component: () => import('pages/public/PageHome.vue'),
        path: '', meta: { auth: false, permission: false },
      },
      { // Login - Admin
        name: 'login_admin', component: () => import('pages/public/PageLoginAdmin.vue'),
        path: 'panel/login', meta: { auth: false, permission: false },
      },
      { // Login
        name: 'login_clientes', component: () => import('pages/public/PageLoginClientes.vue'),
        path: 'login', meta: { auth: false, permission: false },
      },
      { // Registrar
        name: 'registrar', component: () => import('pages/public/registro/PageRegistrar.vue'),
        path: 'registrar',  meta: { auth: false, permission: false },
      },
      { // registrar/validar-codigo
        name: 'registrar_validar_codigo', component: () => import('pages/public/registro/PageValidarCodigo.vue'),
        path: 'registrar/validar-codigo',  meta: { auth: true, permission: true },
      },
      { // Registrar / Finalizar
        name: 'registrar_finalizar', component: () => import('pages/public/registro/PageFinalizar.vue'),
        path: 'registrar/finalizar',  meta: { auth: false, permission: false },
      },
      // { // ForgotPassword
      //   name: 'forgotPassword', component: () => import('pages/App/ViewForgotPassword.vue'),
      //   path: 'forgot-password', meta: { auth: true, permission: true },
      // },
    ],
  },
  // --- --- --- Administradores --- --- ---
  { path: '/admin/', component: () => import('layouts/admin/AdminLayout.vue'),
    children: [
      { // Completar perfil
        name: 'admin_completar_perfil', component: () => import('pages/admin/account/PageCompletarPerfil.vue'),
        path: 'completar/perfil', meta: { auth: true, permission: true },
      },
      // --- --- --- Usuarios --- --- ---
      { // Usuarios
        name: 'admin_users_list',  component: () => import('pages/admin/users/PageIndex.vue'),
        path: 'users', meta: { auth: true, permission: true },
      },
      { // Roles
        name: 'admin_roles_list',  component: () => import('pages/admin/users/roles/PageIndex.vue'),
        path: 'users/roles', meta: { auth: true, permission: true },
      },
      // --- --- --- Procesos --- --- ---
      { // Procesos
        name: 'admin_procesos_list',  component: () => import('pages/admin/procesos/procesos/PageIndex.vue'),
        path: 'procesos', meta: { auth: true, permission: true },
      },
      { // Procesos Pasos
        name: 'admin_procesos_pasos_list',  component: () => import('pages/admin/procesos/procesos-pasos/PageIndex.vue'),
        path: 'procesos-pasos', meta: { auth: true, permission: true },
      },
      { // Procesos Datos
        name: 'admin_procesos_pasos_datos_list',  component: () => import('pages/admin/procesos/procesos-datos/PageIndex.vue'),
        path: 'procesos-datos', meta: { auth: true, permission: true },
      },
    ]
  },
  // --- --- --- Clientes --- --- ---
  { path: '/clientes/', component: () => import('layouts/cliente/ClienteLayout.vue'),
    children: [
      { // Completar perfil
        name: 'cliente_completar_perfil', path: 'completar/perfil',
        meta: { auth: true, permission: true },
        component: () => import('pages/clientes/account/PageCompletarPerfil.vue')
      },
      // // --- --- --- Procesos --- --- ---
      // { // Procesos
      //   name: 'cliente_dashboard',  component: () => import('pages/clientes/procesos/PageDashboard.vue'),
      //   path: 'procesos-dashboard', meta: { auth: true, permission: true },
      // },
    ]
  },
  // --- --- --- Procesos dashboard SIN layout --- --- ---
  { name: 'cliente_dashboard', path: '/clientes/procesos-dashboard',
    meta: { auth: true, permission: true },
    component: () => import('pages/clientes/dashboard/PageDashboard.vue'),
  },
  // --- --- --- Rutas especiales --- --- ---
  // Always leave this as last one,
  // but you can also remove it
  // { path: '/session-expired', component: () => import('pages/ErrorNotFound.vue') },
  { path: '/:catchAll(.*)*', component: () => import('pages/public/error/ErrorNotFound.vue') },
  { path: '/access-denied', component: () => import('pages/public/error/ErrorAccessDenied.vue') },
  { path: '/not-authenticated', component: () => import('pages/public/error/ErrorNotAuthenticated.vue') },
];

export default routes;
